import {APIService} from '@/services/api.service';
import {ChatResponse} from './get-chat-response';

export type DialogResponse = ChatResponse;
// {
//   selected_filters: FilterTag[];
//   response: string;
//   traveler_information: TravelersIndormation;
//   trip_start_time: number;
//   trip_end_time: number;
//   show_destinations: boolean;
//   show_sample_trips: boolean;
//   session_id: string;
//   origin: ProblemDestination;
//   destination: ProblemDestination;
//   budget: null | Budget;
// }

export async function getDialogResponse(input: string, context: string): Promise<DialogResponse | null> {
  try {
    const res = await APIService.post<DialogResponse>(
      `dialog/filter-recommendation/response`,
      {input},
      {
        params: {
          mode: process.env.VUE_APP_MODE,
          context: context,
        },
      },
      true,
    );
    return res;
  } catch (e) {
    return null;
  }
}
